import React from 'react';
import RewardFieldPoin from '@core_modules/amrewards/plugins/fieldpoin';
import { getCartId } from '@helper_cartid';
import gqlService from '@core_modules/amrewards/services/graphql';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectCheckoutState, setIsNewUpdate, setLoading, setCheckoutData, setRefetchItemOnly,
    setErrorState,
} from '@core_modules/checkout/redux/checkoutSlice';

const index = (props) => {
    const {
        t, formik, refetchDataCart, handleOpenMessage,
    } = props;

    const cartId = getCartId();
    const dispatch = useDispatch();
    const checkout = useSelector(selectCheckoutState);
    const loading = checkout?.loading?.points;

    const usedPoints = checkout?.data?.cart?.amasty_rewards_used_points?.used_points || 0;

    const [useRewardPoint] = gqlService.useRewardPoints({ onError: () => { } });
    const isPointsUsed = !!checkout?.data?.cart?.amasty_rewards_used_points?.used_points;

    const handlePoints = async () => {
        let cart;

        dispatch(setLoading({
            all: false,
            shipping: false,
            payment: true,
            extraFee: false,
            order: true,
            points: true,
        }));

        dispatch(setIsNewUpdate(true));

        if (!isPointsUsed) {
            const result = await useRewardPoint({ variables: { cart_id: cartId, points: parseFloat(formik.values.points) } });
            if (result?.data?.useRewardPoints?.cart) {
                cart = {
                    ...checkout.data.cart,
                    ...result?.data?.useRewardPoints?.cart,
                };
            }
            if (cart) {
                let message = t('common:amrewards:point_success');
                let variant = 'message';
                if (result?.data?.useRewardPoints?.response.includes('Too much point')) {
                    message = t('common:amrewards:point_toomuch');
                    variant = 'warning';
                }
                handleOpenMessage({
                    variant,
                    text: message,
                });
            }
        } else {
            const result = await useRewardPoint({ variables: { cart_id: cartId, points: parseFloat(0) } });
            if (result?.data?.useRewardPoints?.cart) {
                formik.setFieldValue('points', '');
                cart = result && {
                    ...checkout.data.cart,
                    ...result?.data?.useRewardPoints?.cart,
                };
                handleOpenMessage({
                    variant: 'success',
                    text: t('common:amrewards:point_cancel'),
                });
            }
        }

        dispatch(setLoading({ points: false }));

        if (cart) {
            dispatch(setErrorState({
                points: false,
            }));
            dispatch(setCheckoutData({
                cart,
            }));
        } else {
            dispatch(setErrorState({
                points: true,
            }));
            await formik.setFieldError('points', t('checkout:message:pointsError'));
        }
        dispatch(setRefetchItemOnly(true));
        dispatch(setLoading({
            all: false,
            shipping: false,
            payment: false,
            extraFee: false,
            order: false,
        }));

        if (refetchDataCart && typeof refetchDataCart === 'function') {
            dispatch(setLoading({
                payment: true,
                order: true,
                points: true,
                shipping: true,
            }));
            await refetchDataCart();
            dispatch(setLoading({
                all: false,
                shipping: false,
                payment: false,
                extraFee: false,
                order: false,
                points: false,
            }));
        }
    };

    return (
        <>
            <RewardFieldPoin
                id="points"
                name="points"
                disabled={false}
                action={handlePoints}
                onChange={formik.handleChange}
                toggleField={isPointsUsed}
                value={formik.values.points}
                usedPoints={usedPoints}
                loading={loading}
            />
        </>
    );
};

export default index;
